<template>
    <div class="conversation">
        <div class="messages">
            <span class="return-list" @click="returnList()">
              <i class="fa fa-reply mr"></i>
              <div class="avatar">
                <img v-bind:src="getAvatarForContact(titleConversation.avatar)" alt="" class="avatar">
                <span>{{ titleConversation.name}}</span>
              </div>
              
            </span>
                    <!-- <div class="message--not--text">
                        This is not a live chat, and is for nonemergent questions
                    </div> -->
                    <div class="no-messages" v-if="!messages.length">
                        <i class="fa fa-comment-alt" ></i>
                        <h2>Looks like you don't have any messages yet.</h2>
                    </div>
                    <div class="error" v-show="hasLoadingBeforeError">
                        Could not retrieve additional messages.
                    </div>
                    <div class="error" v-show="hasSendMessageError">
                        Could not send message.
                    </div>
                    <div class="loading" v-show="isLoadingBefore">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>
                    <div v-for="message in messages" :key="message.id"
                        :class="{ 'message': true, 'my-message': messageIsMine(message) }">
                        <!-- <div class="message--sender">
                            <img v-bind:src="getAvatarForMessage(message)" alt="Message from" class="avatar">
                        </div> -->
                        <div class="message--content">
                            <div class="name">{{ message.sender.firstName }} {{ message.sender.lastName }}</div>
                            <div class="body" v-html="message.body">
                                {{ message.body }}
                            </div>
                        </div>
                        <div class="message--meta">
                            <div class="date">
                                {{ localTime(message.dateCreated.date) }}
                            </div>
                        </div>
                    </div>

                    <div class="loading" v-show="isLoadingSince">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>
        </div>
        <div class="new-message">
            <textarea v-model="newMessageBody" v-on:keyup="detectEnter" placeholder="Send a message..."></textarea>
        </div>
    </div>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';
  export default {
    props: ['messages', 'myPersonId', 'titleConversation'],
    data: function() {
      return {
        isLoadingBefore: false,
        isLoadingSince: false,
        hasLoadingBeforeError: false,
        patients: [],
        newMessageBody: null,
        pollingInterval: 4000,
        isPollingPaused: false,
        hasSendMessageError: false,
      };
    },
    created() {
      //this.getAllUsers();
    },
    mounted() {
      this.scrollToBottom();
    },
    updated() {
      this.scrollToBottom();
    },
    methods: {
      handleScroll() {
        console.log('teste')
        if (this.$el.querySelector('.messages').scrollTop == 0) {
          if (this.messages.length) {
            this.getBefore(this.messages[0]);
          }
        }
      },
      returnList(){
        this.$emit('returnList');
      },
      resetScrollPosition() {
        this.scrollToBottom();
      },
      messageIsMine(message) {
        return message.sender.id == this.myPersonId;
      },
      getAvatarForMessage(message) {
        if (message.sender.avatar) {
          return message.sender.avatar;
        }
        return '/images/default-avatar.png';
      },
      getAvatarForContact(avatar) {
        if (avatar) {
          return avatar;
        }
        return '/images/default-avatar.png';
      },
      getLatestMessageId() {
        if (this.messages.length) {
          return this.messages[this.messages.length - 1].id;
        }
      },
      sendNewMessage() {
        this.isLoadingSince = true;
        this.hasSendMessageError = false;
        this.resetScrollPosition();

        axios
          .post('/api/v1/messages/conversation', { body: this.newMessageBody, from: this.myPersonId, to:this.titleConversation.id,})
          .then((response) => {
            this.isLoadingSince = false;
  
            let data = response.data.data;

            this.messages = data;
  
            this.resetScrollPosition();
          })
          .catch(
            function(error) {
              this.hasSendMessageError = true;
              this.isLoadingSince = false;
            }.bind(this)
          );
      },
      detectEnter(e) {
        if (e.keyCode === 13) {
          this.newMessageBody = this.newMessageBody.trim();
          if (this.newMessageBody) {
            this.sendNewMessage();
            this.newMessageBody = '';
          }
        }
      },
      localTime(datetime) {
        datetime = datetime.replace(/\.000000/, '');
        let utcDate = moment.utc(datetime);
        return moment(utcDate)
          .local()
          .calendar('', { sameElse: 'M/D/YYYY, h:mm A' });
      },
      scrollToBottom() {
        const container = this.$el.querySelector('.messages');
        if (container) {
          this.$nextTick(() => {
            container.scrollTop = container.scrollHeight;
          });
        }
      },
    },
  };
  </script>
  
<style type="sass" scoped>
.return-list{
    padding-bottom: 10px;
    display: flex;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
}

.return-list i{
  float:left;
}
.avatar{
  display: flex;
  align-items: center;
}

.avatar img{
  width: 50px;
}

.avatar span{
  align-items: center;
  margin-left: 10px;
  font-weight: bold;
}

.conversation {

    position: relative;
    padding-bottom: 60px;

    .no-messages {
      padding: 3rem 1.5rem;
      background-color: #fff;
      i {
        color: #243153;
        display: block;
        font-size: 5rem;
        margin-bottom: 1rem;
        text-align: center;
      }
      h2 {
        color: #243153;
        font-size: 1.5rem;
        text-align: center;
      }
      span {
        display: block;
        text-align: center;
      }
    }

    .messages {
      background-color: #fff;
      height: 25rem;
      overflow-y: auto;
      padding: 20px;
    }
    .message {

      margin: 1rem 0;
      &--sender {
        float: right;
        .avatar {
          width: 50px;
        }
        .name {
          display: none;
        }
      }


      &--content {
        background: #fff;
        border-radius: .5rem;
        padding: .75rem;
        margin-right: 70px;
        font-size: .9rem;
        position: relative;
        .name {
          font-size: .6rem;
          font-weight: bold;
          margin-bottom: .5em;
          color: rgba(0,0,0,0.35);
        }
        p {
          margin: 0;
        }
        &:after {
          content: '';
          position: absolute;
          display: block;
          width: 0;
          height: 0;
          top: 18px;
          right: -12px;
          border-top: 8px solid transparent;
          border-left: 12px solid #fff;
          border-bottom: 8px solid transparent;
        }
      }

      &.my-message {
        .message--sender {
          float: left;
        }
        .message--content {
          background: #ccc;
          margin-right: 0;
          margin-left: 70px;

          &:after {
            border-left: none;
            border-right: 12px solid #ccc;
            right: auto;
            left: -12px;
          }
        }
        .message--meta {
          text-align: left;
          margin-left: 70px;
          margin-right: 0;
        }
      }
    }

    .new-message {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      width: 100%;
      textarea {
        background-color: #fafafa;
        border: none;
        border-top: 1px solid #ccc;
        height: 60px;
        box-sizing: border-box;
        width: 100%;
        margin: 0;
        resize: none;
        font-size: .9rem;
        &:focus {
          box-shadow: none;
        }
      }
    }

}
.mr{
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/BoxMessageTab.vue